<template>
  <div>
    <div class="listNav">
      <div class="main">
        <span>您的位置：</span>
        <span>首页</span>
        <span>></span>
        <span>资源库</span>
        <span>></span>
        <span>资源库详情</span>
        <span>></span>
        <span>课程列表</span>
      </div>
    </div>
    <div class="listcenter">
      <div class="main">
        <div class="sort">
          <div class="textType">文本类型:</div>
          <div class="allbox">
            <div :class="{active : active == '全部'}" @click="handleTabAll()" class="all">全部</div>
          </div>
          <div class="item">
            <el-row :gutter="20">
              <el-col :span="4" v-for="(item,j) in branchList" :key="j">
                <div
                  @click="handleTab(item.typeName,item.fid)"
                  :class="{active : active == item.typeName}"
                  class="seachBtn grid-content bg-purple"
                >{{item.typeName}}</div>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="matNav">
          <div class="dataTime">
            <span>默认</span>
          </div>
          <div class="dataTime">
            <span>发布时间</span>
            <i class="el-icon-caret-top iconTop"></i>
            <i class="el-icon-caret-bottom iconBot"></i>
          </div>
          <div class="dataTime">
            <span>热度</span>
            <i class="el-icon-caret-top iconTop"></i>
            <i class="el-icon-caret-bottom iconBot"></i>
          </div>
          <div>
            <el-radio-group v-model="radio">
              <el-radio :label="1">我上传的资源包</el-radio>
            </el-radio-group>
          </div>
          <div class="search">
            <input type="text" placeholder="请输入你要搜索的教材名称" />
          </div>
          <div class="searchBut">搜索</div>
        </div>
      </div>
      <div class="courselist">
        <div class="course">
          <el-row :gutter="20">
            <el-col :span="6" v-for="(item,index) in relevant" :key="index">
              <div class="grid-content bg-purple">
                <router-link to="/repositories/soursedet">
                  <div class="itemnewImg">
                    <img src="../../assets/img/relevantItem.png" alt />
                  </div>
                </router-link>
                <div class="itemTit">新突破大学英语综合教材</div>
                <div class="user">文件大小：10kb</div>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="block">
          <el-pagination layout="prev, pager, next" :total="100"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      radio: 1,
      relevant: [
        { id: 1 },
        { id: 1 },
        { id: 1 },
        { id: 1 },
        { id: 1 },
        { id: 1 },
        { id: 1 },
        { id: 1 },
        { id: 1 },
        { id: 1 },
        { id: 1 },
        { id: 1 }
      ],
      branchList: [
        { typeName: '文本类1' },
        { typeName: '微课类2' },
        { typeName: '文本类3' },
        { typeName: '微课类4' },
        { typeName: '文本类5' },
        { typeName: '微课类6' },
        { typeName: '文本类7' },
        { typeName: '文本类8' },
        { typeName: '微课类9999' },
        { typeName: '文本类10文本类10文本类10文本类10' }
      ],
      active: '全部'
    }
  },
  methods: {
    handleTab(typeName, id) {
      this.active = typeName
    },
    handleTabAll() {
      this.active = '全部'
    }
  }
}
</script>
<style lang="scss" scoped>
.listcenter {
  background: url('../../assets/img/subbg.jpg');
}
.listNav {
  width: 100%;
  height: 42px;
  background: rgba(237, 234, 231, 1);
  span {
    font-size: 14px;
    color: rgba(102, 102, 102, 1);
    line-height: 42px;
    margin-right: 5px;
  }
  :nth-child(8) {
    color: #b50e05;
  }
}
.matNav {
  font-size: 14px;
  color: rgba(102, 102, 102, 1);
  overflow: hidden;
  height: 70px;
  line-height: 40px;
  div {
    float: left;
  }
  .signUp {
    position: relative;
  }
  .iconTop {
    position: absolute;
    top: 9px;
    right: -15px;
    &:hover {
      color: #0b3450;
    }
  }
  .iconBot {
    position: absolute;
    bottom: 9px;
    right: -15px;
    &:hover {
      color: #0b3450;
    }
  }
  .dataTime {
    position: relative;
    margin-right: 30px;
  }
  .search {
    width: 230px;
    height: 34px;
    margin-right: 20px;
    margin-left: 445px;
    input {
      border: none;
      background: rgba(0, 0, 0, 0.1);
      width: 230px;
      height: 34px;
      padding-left: 10px;
    }
  }
  .searchBut {
    width: 77px;
    height: 34px;
    background: rgba(181, 14, 5, 1);
    font-size: 14px;
    color: rgba(255, 255, 255, 1);
    line-height: 34px;
    text-align: center;
    float: right;
    margin-top: 4px;
  }
}
.courselist {
  width: 1112px;
  margin: 0 auto;
  height: 100%;
  background-color: #fff;
  padding-top: 50px;
}
.course {
  margin: 0 30px;
}
.itemnewImg {
  width: 100%;
  height: 150px;
  img {
    height: 100%;
    width: 100%;
  }
}
.itemTit {
  font-size: 16px;
  color: rgba(181, 14, 5, 1);
  margin: 17px 0 22px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.user {
  font-size: 12px;
  color: rgba(102, 102, 102, 1);
  margin-bottom: 50px;
}
.active {
  background: rgba(181, 14, 5, 1);
  border-radius: 2px;
  color: #fff !important;
}
.sort {
  overflow: hidden;
  .textType {
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 33px;
    height: 88px;
    float: left;
    margin-right: 20px;
  }
  .allbox {
    float: left;
    height: 88px;
    .all {
      width: 36px;
      height: 23px;
      // background: rgba(181, 14, 5, 1);
      border-radius: 2px;
      font-size: 14px;
      color: rgba(102, 102, 102, 1);
      line-height: 23px;
      text-align: center;
      margin-right: 30px;
    }
  }
  .item {
    float: left;
    width: 966px;
    .seachBtn {
      // float: left;
      font-size: 14px;
      color: rgba(102, 102, 102, 1);
      // min-width: 60px;
      width: 70px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      // max-width: 160px;
      overflow: hidden;
    }
  }
}
</style>